import React from "react"
import { Link } from "gatsby"
import _ from "lodash"
import { SingleTagStyle } from "./style"

interface TagProps {}

const Tag: React.FunctionComponent<TagProps> = props => {
  return (
    <SingleTagStyle>
      <Link style={{'color': 'white'}} to={`/tags/${_.kebabCase(props.name)}/`}> {"#" + props.name}</Link>
    </SingleTagStyle>
  )
}

export default Tag
